export const navLinks = [
  { label: "今日更新", href: "#today" },
  { label: "新内容速递", href: "#feed" },
  { label: "最新合集", href: "#collection" },
  { label: "热门板块", href: "#hot" },
  { label: "社区热聊", href: "#talk" },
];

export const statItems = [
  { value: "今日上新", num: "18", unit: "组资源" },
  { value: "持续更新", num: "328", unit: "天不间断" },
  { value: "已收录合集", num: "126", unit: "份系列" },
  { value: "站内热聊", num: "4.2", unit: "万帖" },
];

export const feedTabs = ["全部速递", "影视动画", "实用工具", "学习资料", "壁纸素材", "同好共创"];

export const todayItems = [
  {
    time: "刚刚",
    tag: "学习资料",
    dot: "新",
    title: "「新内容速递」零基础写作课 · 第三期全量更新",
    desc: "本周主讲人补录 4 节精讲，配套素材与课后作业同步整理，追更的朋友可以直接从第一节顺读。",
    views: "2.1k",
    comments: "186",
  },
  {
    time: "10:40",
    tag: "实用工具",
    dot: "热",
    title: "桌面效率工具合集今日上新 5 款轻量应用",
    desc: "覆盖笔记、待办与截图标注，均为免安装便携版，评论区已有多位用户附上手感体验。",
    views: "1.4k",
    comments: "97",
  },
  {
    time: "09:15",
    tag: "影视动画",
    dot: "荐",
    title: "冷门动画补番清单 · 深夜档精选更新至 Vol.22",
    desc: "本期收录 6 部口碑向作品，附无剧透短评与在线/下载入口，适合周末慢慢补。",
    views: "3.6k",
    comments: "243",
  },
  {
    time: "昨日 22:30",
    tag: "壁纸素材",
    dot: "",
    title: "高清壁纸包 · 城市夜景系列补全 4K 版",
    desc: "原 1080P 版本全部替换为 4K 无损，新增 12 张长截图适用比例，压缩包已重新整理打包。",
    views: "980",
    comments: "54",
  },
];

export const collections = [
  {
    featured: true,
    title: "影视动画·新番速报总合集",
    desc: "把每日更新的新番信息按季归档，附开播时间与追番日历，一次收藏反复翻查。",
    tag: "长期合集",
    items: "已累计 32 期",
    update: "今日 11:00 更新",
    heat: "8.9k 追更",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20collection%20moodboard%20with%20vintage%20film%20reels%20and%20cozy%20theater%20seats%20in%20soft%20coral%20and%20cream%20tone%2C%20soft%20lighting%2C%20editorial%20photography%2C%20clean%20composition&width=900&height=600&seq=fuli-col-film&orientation=landscape",
  },
  {
    title: "实用工具 · 装机必备清单",
    desc: "从编辑器到录屏，覆盖常用场景的免安装工具集合，随用随更。",
    tag: "长期合集",
    items: "内含 68 件",
    update: "今日 09:40 更新",
    heat: "5.6k 追更",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20flat%20layout%20of%20desktop%20productivity%20gadgets%20and%20folders%20on%20warm%20beige%20desk%2C%20cozy%20home%20office%2C%20soft%20natural%20light%2C%20clean%20aesthetic&width=500&height=400&seq=fuli-col-tool&orientation=landscape",
  },
  {
    title: "学习资料 · 自学路线合集",
    desc: "汇总从入门到进阶的公开课程与讲义，按难度分级整理。",
    tag: "系列合集",
    items: "内含 41 份",
    update: "昨日 21:00 更新",
    heat: "3.2k 追更",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20study%20corner%20with%20stacked%20notebooks%20and%20open%20book%20on%20warm%20desk%20lamp%20light%2C%20cream%20and%20peach%20palette%2C%20soft%20shadows%2C%20clean%20minimalist&width=500&height=400&seq=fuli-col-study&orientation=landscape",
  },
  {
    title: "壁纸素材 · 四季图库",
    desc: "按季节分卷更新的高清图库，分辨率与屏幕适配已整理归档。",
    tag: "长期合集",
    items: "内含 200+ 张",
    update: "本周二更新",
    heat: "4.1k 追更",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20seasonal%20wallpaper%20mood%20in%20warm%20coral%20and%20golden%20sunset%20gradient%2C%20artistic%20soft%20bokeh%2C%20high%20detail%2C%20calm%20composition&width=500&height=400&seq=fuli-col-wall&orientation=landscape",
  },
  {
    title: "同好共创 · 用户投稿精选",
    desc: "把社区里优质的用户作品按主题归类，给创作者一个展示角落。",
    tag: "共创合集",
    items: "收录 57 篇",
    update: "本周日更新",
    heat: "1.9k 追更",
    cover:
      "https://readdy.ai/api/search-image?query=Creative%20community%20collage%20of%20hand%20drawings%20and%20design%20sketches%20on%20warm%20paper%20background%2C%20soft%20peach%20tones%2C%20clean%20and%20calm&width=500&height=400&seq=fuli-col-creat&orientation=landscape",
  },
];

export const hotBoards = [
  { rank: "01", name: "新番追更", count: "1.2万帖", trend: "+18%", up: true },
  { rank: "02", name: "工具安利", count: "8600帖", trend: "+9%", up: true },
  { rank: "03", name: "学习打卡", count: "6100帖", trend: "-3%", up: false },
  { rank: "04", name: "壁纸搬运", count: "5200帖", trend: "+12%", up: true },
  { rank: "05", name: "好物求推", count: "4700帖", trend: "+5%", up: true },
  { rank: "06", name: "同好创作", count: "2900帖", trend: "-1%", up: false },
];

export const talkTopics = [
  {
    board: "新番追更",
    title: "昨晚那部深夜番的后劲真的太大了，有没有人同感？",
    author: "追更的猫",
    replies: "312",
    time: "8 分钟前",
  },
  {
    board: "实用工具",
    title: "求一个能本地离线用的便签工具，颜值要在线",
    author: "冲浪选手",
    replies: "89",
    time: "32 分钟前",
  },
  {
    board: "学习资料",
    title: "零基础自学三个月，把踩过的坑整理成了一份清单",
    author: "慢慢来同学",
    replies: "156",
    time: "1 小时前",
  },
  {
    board: "壁纸素材",
    title: "今日 4K 城市夜景那批图，导出后色差处理得当吗？",
    author: "像素控",
    replies: "47",
    time: "2 小时前",
  },
  {
    board: "同好创作",
    title: "用站里素材做了套拟物风图标，大家帮我看看",
    author: "岛民小K",
    replies: "203",
    time: "3 小时前",
  },
];

export const footerLinks = {
  quick: [
    { label: "今日更新", href: "#today" },
    { label: "新内容速递", href: "#feed" },
    { label: "最新合集", href: "#collection" },
    { label: "热门板块", href: "#hot" },
    { label: "社区热聊", href: "#talk" },
  ],
  about: ["关于福利岛", "更新日志", "内容规范", "投稿合作", "联系我们"],
  help: ["常见问题", "搜索帮助", "版权说明", "意见建议", "友情链接"],
};